/**
 * Key / Value pair to translate API keys to better named, camelCased keys.
 * Any keys included in the request / response will be and not mapped here
 * will be removed.
 *
 * @var {Object} productMap
 */
var productMap = {
  active: 'active',
  brand_id: 'brandId',
  brand_name: 'brandName',
  brand_weight: 'brandWeight',
  campaign: 'campaign',
  claim_image: 'claimImageFilename',
  claim_image_url: 'claimImageUrl',
  created_at: 'createdAt',
  description: 'description',
  handling_fee: 'handlingFee',
  huggg_tag: 'hugggTag',
  id: 'id',
  image: 'imageFilename',
  images: 'images',
  image_url: 'imageUrl',
  imessage_image: 'iMessageImageFilename',
  imessage_image_url: 'iMessageImageUrl',
  integration: 'integration',
  label: 'label',
  on_app: 'onApp',
  on_imessage: 'onIMessage',
  open_graph_image: 'openGraphImageFilename',
  open_graph_image_url: 'openGraphImageUrl',
  merchandising_title: 'merchandisingTitle',
  merchandising_subtitle: 'merchandisingSubtitle',
  merchandising_image: 'merchandisingImageFilename',
  merchandising_image_url: 'merchandisingImageUrl',
  merchandising_image_detailed_url: 'merchandisingImageDetailedUrl',
  over_18_offer: 'over18Offer',
  price: 'price',
  recipient_description: 'recipientDescriptionCopy',
  redemption_instructions: 'recipientInstructionsCopy',
  sale_price: 'salePricePence',
  search_tags: 'searchTags',
  subtitle: 'subtitle',
  tag_group_id: 'tagGroupId',
  tag_id: 'tagId',
  updated_at: 'updatedAt',
  vat: 'vat',
  vat_voucher_type: 'vatVoucherType',
  voucher: 'voucher',
  weight: 'weight'
};
export default productMap;